import Image from 'next/legacy/image';
import Link from 'next/link';

import { BodyRegular } from '@common/body';
import { H5 } from '@common/headline';
import { ImageCard } from '@common/ImageCard';
import { HomeFeaturedArticleType } from '@nextTypes/guides';

export const createImageCards = (
  articles: HomeFeaturedArticleType[],
  quantity: number,
  descriptions = true,
): React.ReactElement[] => {
  const cards = [];

  for (let i = 0; i < quantity; i++) {
    if (i < articles.length) {
      cards.push(
        <div
          className="mb-6 lg:mb-0 lg:mr-6 lg:last:odd:hidden xl:mr-0 xl:last:odd:flex"
          key={articles[i].href}
        >
          <ImageCard
            key={articles[i].href}
            image={articles[i].backgroundImage}
            title={articles[i].title}
            altText={articles[i]?.description || ''}
            subtitle={descriptions ? articles[i]?.description : ''}
            href={articles[i].href}
          />
        </div>,
      );
    } else {
      cards.push(
        <div className="w-[351px] lg:last:odd:hidden xl:last:odd:flex"></div>,
      );
    }
  }

  return cards;
};

export const createBlogImageCards = (
  articles: HomeFeaturedArticleType[],
): React.ReactElement[] =>
  articles.map(article => (
    <Link href={article.href} key={article.href}>
      <div className="mb-6 flex cursor-pointer flex-col lg:flex-row">
        <div className="relative h-[131px] w-[164px] odd:mr-6 lg:mr-6 lg:h-[169px] lg:min-w-[200px]">
          <Image
            src={article.backgroundImage}
            alt={article.description || ''}
            layout="fill"
            objectFit="cover"
            className="rounded-3xl"
          />
        </div>
        <div className="flex h-[131px] flex-col justify-between">
          <div className="mt-4 flex max-w-[164px] cursor-pointer text-mono-white lg:max-w-none">
            <H5>{article.title}</H5>
          </div>
          <div className="flex text-blue-200">
            <BodyRegular>{article.authorName}</BodyRegular>
          </div>
        </div>
      </div>
    </Link>
  ));
